import { useEffect } from 'react';
import Navbar from '../Components/navbar'
import Footer from '../Components/Footer';
import './Contact.css'
export default function Contact() {

useEffect(() => {
       window.scrollTo(0, 0); // Scroll to the top of the page
     }, []);



  return (
    <>
    <Navbar/>
    
    
    <section id="getin" className="getin-section">
  <div className="getin-container">
    <div className="getin-left">
      <h2>Get In Touch</h2>
      <p>Welcome to OM Enterprise Private Limited</p>
      <div className="contact-info">
        <p><strong>Phone:</strong><br />+91 9944210143</p>
        <p><strong>Phone:</strong><br />+91 9944288801</p>
        <p><strong>Email:</strong><br />om_enterprises@hotmail.co.in</p>
        <p><strong>Registered Address:</strong><br />
          Second Floor, Old No.5, New No.10, TRK Road,T.V Colony, Andalpuram, Madurai-625003 (INDIA)
        </p>
        <p><strong>Branch Address:</strong><br />
          8/2 RAJA STREET, SUBRAMANIYA PURAM MADURAI-625011(INDIA)
        </p>
      </div>
    </div>

    <form className="getin-form">
      <div className="form-row">
        <input type="text" placeholder="Company Name" />
        <input type="text" placeholder="Person Name" />
        <input type="text" placeholder="Designation" />
      </div>
      <div className="form-row">
        <input type="text" placeholder="Country Code (+91)" />
        <input type="text" placeholder="Mobile No" />
        <input type="email" placeholder="E-Mail" />
      </div>
      <textarea placeholder="Message"></textarea>

      {/* <div className="captcha-box">
        <label>Type the characters from the picture:</label>
        <img src="/captcha-demo.png" alt="captcha" />
        <button type="button" className="refresh-btn">Refresh</button>
        <input type="text" placeholder="Type here characters from the picture" />
      </div> */}

      <button type="submit" className="submit-btn">SUBMIT</button>
    </form>
  </div>
</section>

    
    <Footer/>
    </>
  )
}
